import { motion } from "framer-motion";
import { Overline } from "../Reveal";
import { ThreatMap } from "../ThreatMap";

export const ThreatSection = () => (
  <section
    id="amenazas"
    className="relative mx-auto max-w-7xl px-5 py-28 md:px-10 md:py-40"
    data-testid="threat-section"
  >
    <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <div>
        <Overline>Amenazas en vivo</Overline>
        <h2 className="mt-6 max-w-2xl font-head text-4xl font-bold tracking-tight text-white md:text-5xl">
          El ciberespacio nunca duerme
        </h2>
      </div>
      <p className="max-w-xs font-sans text-sm text-white/50">
        Mapa mundial de ciberataques. Visualización con datos simulados, alimentada en tiempo real por los escaneos de nuestros usuarios.
      </p>
    </div>

    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="mt-12"
    >
      <ThreatMap />
    </motion.div>
  </section>
);
